 function applyColorMap(root = document) {
    const colorMap = {
      "01rosyglow": "#FF7588",
      "02softrose": "#FE8E8D",
      "03toffeeglaze": "#F2875D",
      "19nfairlight": "#fce5c9",
      "21nlight": "#f8dab0",
      "23nnatural": "#efcfb3",
      "25ntan": "#f2c6a5"
    };

    root.querySelectorAll("*").forEach(function (el) {
      let style = el.getAttribute("style");
      if (style) {
        Object.keys(colorMap).forEach(function (key) {
          const regex = new RegExp(key, "g");
          style = style.replace(regex, colorMap[key]);
        });
        el.setAttribute("style", style);
      }

      if (el.children.length === 0) {
        let text = el.textContent;
        if (text.includes("เฉดสีs")) {
          el.textContent = text.replace(/เฉดสีs/g, "เฉดสี");
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Initial apply after short delay
    setTimeout(() => applyColorMap(), 500);

    // Set up a MutationObserver to detect changes (e.g. via AJAX)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            applyColorMap(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });